export default {
  audience: [],
  title: '',
  content: '',
  status: 'draft'
};
